import { useServices } from 'containers/services';
import type { GetFilesArg, GetFilesResponse } from 'lib/services/backend-gateway/filesApi';
import { isEmpty } from 'ramda';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useFiles = (
  filter: GetFilesArg | undefined = {},
  options: UseQueryOptions<GetFilesResponse> = {},
): UseQueryResult<GetFilesResponse> => {
  const {
    backendGateway: { filesApiClient },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.files.filter(filter),
    queryFn: async () => await filesApiClient.get(filter),
    enabled: !isEmpty(filter),
    onError: console.error,
    ...(options && options),
  });
};
